import React from 'react';
import { useState } from "react";
import { MdAdd, MdRemove } from "react-icons/md";

const Faq = () => {
    
    // faq
    const [activeIndex, setActiveIndex] = useState(null);
  
    const toggleFaq = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
    };
    
    return (
        <>
            <section id="faq">
                <div className="container">
                    <h2 className="title">FAQs</h2>
                    <p className="desc">Most frequently asked questions</p>
                    <div className="faqMain">
                        <div className="faqHead">
                            <div className="faqHeadBox">
                                <h3>200,000+</h3>
                                <span>Students</span>
                            </div>
                            <div className="faqHeadBox">
                                <h3>300+</h3>
                                <span>Experts</span>
                            </div>
                            <div className="faqHeadBox">
                                <h3>98%</h3>
                                <span>Success Rate</span>
                            </div>
                        </div>
                        <div className="faqList">
                            <div className={`faqBox ${activeIndex === 0 ? "active" : ""}`} onClick={() => toggleFaq(0)} >
                                <div className="faqBoxHead">
                                    <h3>What courses does Neethu's Academy offer?</h3>
                                    <div className="faqBoxHeadIcon">
                                        {activeIndex === 0 ? <MdRemove /> : <MdAdd />}
                                    </div>
                                </div>
                                <div className="faqBoxBody" style={{ maxHeight: activeIndex === 0 ? "500px" : "0" }}>
                                    <div className="faqBoxBodyMain">
                                        <p>Neethu’s Academy holds a varied specializations in courses such as OET (Occupational English Test), IELTS (International English Language Testing System), PTE (Pearson Test of English), German language proficiency exams, TOEFL (Test of English as a Foreign Language), NCLEX-RN( National Council Licensure Examination for Registered Nurses) and CBT (Computer-Based Test) preparation.</p>
                                    </div>
                                </div>
                            </div>
                            <div className={`faqBox ${activeIndex === 1 ? "active" : ""}`} onClick={() => toggleFaq(1)} >
                                <div className="faqBoxHead">
                                    <h3>What makes Neethu's Academy different from other test preparation centers?</h3>
                                    <div className="faqBoxHeadIcon">
                                        {activeIndex === 1 ? <MdRemove /> : <MdAdd />}
                                    </div>
                                </div>
                                <div className="faqBoxBody" style={{ maxHeight: activeIndex === 1 ? "500px" : "0" }}>
                                    <div className="faqBoxBodyMain">
                                        <p>Neethu’s Academy stands out due to its exclusive and undisputed focus on language proficiency and standardized test preparation. We offer personalized attention, flexible learning options, comprehensive study materials, and a supportive learning environment tailored to each student’s needs.</p>
                                    </div>
                                </div>
                            </div>
                            <div className={`faqBox ${activeIndex === 2 ? "active" : ""}`} onClick={() => toggleFaq(2)} >
                                <div className="faqBoxHead">
                                    <h3>How does Neethu's Academy ensure personalized learning?</h3>
                                    <div className="faqBoxHeadIcon">
                                        {activeIndex === 2 ? <MdRemove /> : <MdAdd />}
                                    </div>
                                </div>
                                <div className="faqBoxBody" style={{ maxHeight: activeIndex === 2 ? "500px" : "0" }}>
                                    <div className="faqBoxBodyMain">
                                        <p>We provide personalized learning through one-on-one sessions, and customized study plans tailored specifically for the individual’s needs. This approach allows us to cater to the unique strengths and weaknesses of each student, maximizing their learning potential.</p>
                                    </div>
                                </div>
                            </div>
                            <div className={`faqBox ${activeIndex === 3 ? "active" : ""}`} onClick={() => toggleFaq(3)} >
                                <div className="faqBoxHead">
                                    <h3>What are the success rates of students at Neethu's Academy?</h3>
                                    <div className="faqBoxHeadIcon">
                                        {activeIndex === 3 ? <MdRemove /> : <MdAdd />}
                                    </div>
                                </div>
                                <div className="faqBoxBody" style={{ maxHeight: activeIndex === 3 ? "500px" : "0" }}>
                                    <div className="faqBoxBodyMain">
                                        <p>Neethu’s Academy has a strong and proven track record of success, with many students achieving their target scores in exams like IELTS, OET, PTE, and other competitive exams. Our success is a testament to our effective teaching methods and commitment to student excellence.</p>
                                    </div>
                                </div>
                            </div>
                            <div className={`faqBox ${activeIndex === 4 ? "active" : ""}`} onClick={() => toggleFaq(4)} >
                                <div className="faqBoxHead">
                                    <h3>How can I enroll in courses at Neethu's Academy?</h3>
                                    <div className="faqBoxHeadIcon">
                                        {activeIndex === 4 ? <MdRemove /> : <MdAdd />}
                                    </div>
                                </div>
                                <div className="faqBoxBody" style={{ maxHeight: activeIndex === 4 ? "500px" : "0" }}>
                                    <div className="faqBoxBodyMain">
                                        <p>To enroll in courses at Neethu’s Academy, you can visit our website or contact us directly via phone or email. Our admissions team will guide you through the enrollment process and help you choose the right course based on your goals and schedule.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Faq;